import flatten from 'lodash/flatten'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

export const buildAllocationsOptionsProp = (allocationsDataset, hideLegend, semiCircle) => {
  const dataIsEmpty = isEmpty(flatten(allocationsDataset))
  const options = {
    aspectRatio: 3/2,
    circumference: semiCircle ? 180 : 360,
    rotation: -90,
    cutout: '25%',
    plugins: plugins(hideLegend, dataIsEmpty)
  }

  return options
}

const plugins = (hideLegend, dataIsEmpty) => ({
  crosshair: false,
  legend: legend(hideLegend),
  tooltip: tooltips(dataIsEmpty, hideLegend),
})

const legend = (hideLegend) => ({
  display: !hideLegend,
  position: 'right',
  align: 'center'
})

const tooltips = (dataIsEmpty, hideLegend) => ({
  callbacks: {
    enabled: !dataIsEmpty,
    title: hideLegend ? () => '' : titleCallback,
    label: labelCallback
  }
})

const titleCallback = (tooltipItemArray) => {
  const datasetIndex = tooltipItemArray[0].datasetIndex
  const title = tooltipItemArray[0].dataset.label
  return title
}

const labelCallback = (tooltipItem) => {
  const label = get(tooltipItem, 'label')
  const value = get(tooltipItem, 'formattedValue')

  return `${label} ${value}%`
}
